module.exports = __webpack_public_path__ + "img/shoyu_menu3.7108c5c1.png";